<template>
  <div class="t-video-exercise" v-if="isLoading">
    <div class="t-video-header">
      <img src="../../assets/images/terminal/4.png" class="title-stars" />
      <span class="terminal-title">随堂练习</span>
    </div>
    <div class="t-video-exercise-container" id="question-id">
      <div class="go-back">
        <i class="el-icon-arrow-left" @click="onGoBack">返回</i>
      </div>
      <div class="t-left column">
        <div class="select-but" @click="onSelectStage">
          {{ stageIng.id ? stageIng.name + "," + subjectIng.name : "请选择" }}
        </div>
        <!-- <div class="back-button column" @click="onGoBack">确定</div> -->
        <el-button
          type="warning"
          class="back-button"
          :disabled="questionIds.length == 0"
          :loading="isSubmit"
          @click="onSubmit"
          >提交打印</el-button
        >
        <span class="msg-text">当前个数（{{ questionIds.length }}）题</span>
      </div>
      <div class="t-center">
        <template v-if="!isEmpty">
          <div class="question-item">
            <!-- <el-checkbox v-model="checked"></el-checkbox> -->
            <div
              class="stem"
              v-html="numHtml(this.query.page, data.question.topic)"
            ></div>
            <div
              class="stem"
              v-html="data.question.subtitle"
              v-if="data.question.subtitle"
            ></div>
            <div class="options-box clearfix">
              <div
                class="options"
                v-for="(item, index) in data.question.option"
                :key="index"
              >
                <div class="o-item" v-html="optionHtml(index, item)"></div>
              </div>
            </div>
            <div class="clearfix">
              <div class="question-answers m5">
                作答结果：<span v-if="data.result == 1" class="success">对</span
                ><span v-else class="error">错</span>
              </div>
              <div class="question-answers m5">
                您的答案：{{ data.user_answer }}
              </div>
              <div class="question-answers m5">
                正确答案：<span>{{ data.question.answer }}</span>
              </div>
              <div class="analysis" v-html="data.question.analysis"></div>
            </div>
          </div>
        </template>
        <div class="empty-section column" v-else>暂无错题</div>
      </div>
    </div>
    <div class="answers active column">
      <div class="item column disabled" v-if="this.query.page == 1">
        <i class="el-icon-d-arrow-left item-icon"></i>
      </div>
      <div class="item column" @click="onStep()" v-else>
        <i class="el-icon-d-arrow-left item-icon"></i>
      </div>
      <div class="item column" @click="onStar">
        <i
          class=" item-icon"
          :class="[isActive ? 'el-icon-star-on' : 'el-icon-star-off']"
        ></i>
      </div>
      <div
        class="item column disabled"
        v-if="this.totalCount == this.query.page"
      >
        <i class="el-icon-d-arrow-right item-icon"></i>
      </div>
      <div class="item column" @click="onNext" v-else>
        <i class="el-icon-d-arrow-right item-icon"></i>
      </div>
    </div>
    <div class="dialog" v-if="isDialog">
      <div class="window">
        <div class="dialog-box">
          <div
            class="stage-section"
            v-for="item in stageSubjectList"
            :key="item.id"
          >
            <div>{{ item.name }}</div>
            <div class="subject-list flex-wrap-start">
              <div
                class="subject-item"
                v-for="v in item.children"
                @click="onSelectSubject(item, v)"
                :key="v.id"
                :class="{ active: subjectIng.id == v.id }"
              >
                {{ v.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column init-box" v-else>
    <i class="el-icon-loading fs-20"></i>
    <div class="fs-20">正在出题中</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: {
        page: 1,
        pageSize: 1,
      },
      isEmpty: false,
      totalCount: 0,
      isDialog: false,
      isLoading: false,
      list: [],
      isSubmit: false,
      listCount: 0,
      userErrorQuestion: [],
      stageIng: {},
      subjectIng: {},
      stageSubjectList: [],
      isActive: false,
      questionIds: [],
      data: {},
    };
  },
  created() {
    this.uuid = this.$route.query.uuid;
    this.num = 10;
    this.getQuestion();
    this.getStageSubjec();
  },
  methods: {
    getStageSubjec() {
      this.getRequest("/wenjiaoopne/getStageSubject", { status: 0 })
        .then((result) => {
          this.stageSubjectList = result.data;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getQuestion() {
      this.getRequest(
        "/wenjiaoopne/terminal/question/getErrorQuestionList",
        Object.assign(this.query, { 
          uuid: this.uuid,
          result: 0,
          stage_id: this.stageIng.id,
          subject_id: this.subjectIng.b_subject_id
        })
      )
        .then((result) => {
          this.isEmpty = false;
          if (result.error_code > 0 || result.data.list.length === 0) {
            // this.$message.warning("错题已浏览完");
            this.isEmpty = true;
            return false;
          }
          this.data = result.data.list[0];
          this.totalCount = result.data.page_total;
          this.initStar();
          this.mathJaxInit();
          this.isLoading = true;
        })
        .catch(() => {});
    },
    onStar() {
      let _index = this.questionIds.indexOf(this.data.question_id);
      if (_index > -1) {
        this.questionIds.splice(_index, 1);
        this.isActive = false;
        return false;
      }
      if (this.questionIds.length >= 10) {
        this.$message.error("每次最多10题打印");
        return;
      }
      this.questionIds.push(this.data.question_id);
      this.isActive = true;
    },
    initStar() {
      this.isActive = false;
      if (this.questionIds.indexOf(this.data.question_id) > -1) {
        this.isActive = true;
      }
    },
    onSelectStage() {
      this.isDialog = true;
    },
    onSelectSubject(stage, subject) {
      this.stageIng = stage;
      this.subjectIng = subject;
      this.isDialog = false;
      this.$set(this.query, "page", 1);
      this.getQuestion();
    },
    onStep() {
      this.$set(this.query, "page", --this.query.page);
      this.getQuestion();
    },
    onNext() {
      this.$set(this.query, "page", ++this.query.page);
      this.getQuestion();
    },
    onSubmit() {
      this.isSubmit = true;
      this.postRequest("/wenjiaoopne/terminal/question/penExport", {
        uuid: this.uuid,
        question_id: this.questionIds.join(),
      })
        .then((result) => {
          this.isSubmit = false;
          if (result.error_code > 0 || !result.data.is_exist) {
            this.$message.error("网络错误");
            return false;
          }
          let pdf = encodeURIComponent(result.data.url);
          window.location.href = `http://100.canpoint.net/#/terminal/question?pdf=${pdf}&istrue=1`;
        })
        .catch(() => {
          this.isSubmit = false;
        });
    },
    mathJaxInit() {
      setTimeout(() => {
        this.$nextTick(function() {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("question-id"); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
    onGoBack() {
      window.location.href = `http://100.canpoint.net/#/terminal/question?pdf=0&istrue=0`
    },
  },
};
</script>
<style scoped>
.t-video-exercise {
  position: relative;
  max-width: 1200px;
  height: 340px;
  margin: 0 auto;
  font-size: 24px;
}
.go-back {
  position: absolute;
  top: 40px;
  left: 10px;
  z-index: 100;
  color: #fff;
}
.fs-20 {
  font-size: 24px;
}
.init-box {
  height: 340px;
}
.title-stars {
  width: 56px;
  height: 20px;
  margin-left: 40px;
}
.terminal-title {
  margin-left: 15px;
  color: #ffba0e;
}
.knowledge-img {
  width: 206px;
}
.el-icon-star-on {
  color: #666 !important;
}

.select-but {
  width: 85%;
  margin: 90px 0 90px;
  text-align: center;
  color: #fff;
}
.t-video-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 39px;
  background-image: url("../../assets/images/terminal/top_1.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 1;
}
.t-video-exercise-container {
  position: relative;
  width: 100%;
  height: 340px;
}
.t-video-exercise .t-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 26%;
  max-width: 200px;
  height: 340px;
  background-image: url("../../assets/images/terminal/1.png");
}

.t-video-exercise .t-left .t-knowledge {
  height: 150px;
  overflow-y: auto;
}
.t-video-exercise .t-left .knowledge-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 5px 0;
  color: #fff;
}
.t-video-exercise .t-left .subimt {
  margin-top: 10px;
}

.t-video-exercise .t-left .back-button {
  margin-top: 10px;
  width: 80%;
  max-width: 170px;
  height: 45px;
  border-radius: 25px;
  color: #6e3e1b;
  cursor: pointer;
  font-size: 22px;
}
.msg-text {
  margin-top: 10px;
  font-size: 16px;
  color: #f1f1f1;
}
.t-video-exercise .is_disabled {
  -moz-opacity: 0.6;
  filter: alpha(opacity=60);
  opacity: 0.6;
}
.t-video-exercise .t-center {
  padding: 45px 55px 0 26%;
  height: 295px;
  overflow-y: auto;
}
.t-video-exercise .question-item {
}
.t-video-exercise .t-center .stem {
  padding: 10px 0 5px 0;
}

.t-video-exercise .t-center .o-item {
  padding: 5px 0 0 10px;
}

.t-video-exercise .t-center .analysis {
  padding: 0 10px;
}
.t-video-exercise .t-center .question-answers {
  padding: 0 10px;
}
.t-video-exercise .answers {
  position: absolute;
  height: 340px;
  top: 0;
  right: 0;
  background: #fff;
}
.t-video-exercise .answers .item {
  /* width: 35px; */
  height: 70px;
  text-align: center;
  line-height: 70px;
  border-radius: 35px 0px 0px 35px;
  background-color: #ffab33;
  margin: 10px 0;
  padding: 0 5px 0 8px;
  cursor: pointer;
  font-size: 22px;
}
.t-video-exercise .answers .disabled {
  background-color: #ffdeaf !important;
}
.t-video-exercise .answers .active {
  background-color: #ff7625;
}

.t-video-exercise .mt10 {
  margin-top: 5px;
}
.m5 {
  margin: 2px 0;
}
.t-video-exercise .success {
  color: #67c23a;
}
.t-video-exercise .error {
  color: red;
}

.dialog {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #67c23a;
}
.dialog .dialog-box {
  position: absolute;
  width: 550px;
  height: 200px;
  top: 40px;
  left: 100px;
  border-radius: 5px;
  background-color: #fff;
  z-index: 1000;
  padding: 30px;
  overflow-y: auto;
}
.dialog .dialog-box .subject-list {
  margin-left: 30px;
}
.dialog .window::after {
  position: fixed;
  content: "";
  width: 100%;
  height: 100%;
  display: block;
  z-index: 999;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: rgba(0, 0, 0, 0.3);
}
.dialog .stage-section {
}
.empty-section{
  height: 100%;
}
.item-icon {
  font-size: 30px;
  color: #fff;
}
.dialog .subject-item {
  padding: 10px 15px;
  background-color: #dddddd;
  margin: 10px;
  border-radius: 5px;
}
.dialog .subject-item:hover {
  background-color: #ffab33;
  color: #fff;
}
.dialog .active {
  background-color: #ffab33;
  color: #fff;
}
.m5 {
  margin: 10px 0;
}
</style>
